import { useEffect } from 'react';
import { addBreadcrumbSchema } from '../../Components/helpers';

type CompanyPageBreadcrumbsProps = {
  companyName?: string;
};

export function CompanyPageBreadcrumbs({ companyName }: CompanyPageBreadcrumbsProps) {
  useEffect(() => {
    if (!companyName) {
      return;
    }

    const script = addBreadcrumbSchema([
      {
        name: 'Пошук вакансій за компаніями',
        item: `https://${window.location.host}/search-by-companies`,
      },
      { name: `Профіль компанії ${companyName}` },
    ]);

    return () => {
      if (script && document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, [companyName]);

  // Nothing to render in the DOM, we only need the JSON-LD script in <head>
  return null;
}
